import React from 'react';

/**
 * Simple inline SVG anatomical diagram showing the 7 Jackson-Pollock
 * skinfold measurement sites, with numbered markers matching the field
 * order in <CaliperCalculator />.
 *
 * We ship this as inline SVG (not an external image asset) so:
 *   • Zero extra network requests
 *   • Automatic dark/light mode via `currentColor`
 *   • Perfect scaling on any DPI without loss
 *   • No stock-photo licensing headaches
 *
 * The 7 sites are numbered here in the JP-7 canonical order:
 *   1 chest, 2 midaxillary, 3 triceps, 4 subscapular,
 *   5 abdomen, 6 suprailiac, 7 thigh
 */
const CaliperSitesIllustration = () => (
  <svg
    viewBox="0 0 240 380"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="A 7 kaliperelési pont anatómiai elhelyezkedése"
    className="w-full h-full"
  >
    {/* Human silhouette — front view (simplified) */}
    <g fill="none" stroke="#334155" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">
      {/* Head */}
      <circle cx="120" cy="40" r="22" fill="#f1f5f9" />
      {/* Neck */}
      <path d="M 108 60 L 108 74 L 132 74 L 132 60" fill="#f1f5f9" />
      {/* Torso: shoulders → armpits → waist */}
      <path
        d="M 80 78 Q 70 82 68 96
           L 62 130 Q 60 140 66 148
           L 78 190 Q 82 200 84 214
           L 92 258 Q 96 268 102 268
           L 138 268 Q 144 268 148 258
           L 156 214 Q 158 200 162 190
           L 174 148 Q 180 140 178 130
           L 172 96 Q 170 82 160 78
           Q 140 74 120 74 Q 100 74 80 78 Z"
        fill="#f1f5f9"
      />
      {/* Arms — left */}
      <path
        d="M 66 96 Q 52 100 46 118 L 40 168 Q 38 180 42 194 L 48 232"
        fill="none"
      />
      {/* Arms — right */}
      <path
        d="M 174 96 Q 188 100 194 118 L 200 168 Q 202 180 198 194 L 192 232"
        fill="none"
      />
      {/* Thighs */}
      <path
        d="M 96 268 L 92 356 M 144 268 L 148 356"
        fill="none"
      />
    </g>

    {/* Yellow numbered markers */}
    {[
      { n: 1, x: 100, y: 108, label: 'Mellkas'      },
      { n: 2, x: 78,  y: 130, label: 'Hónaljvonal'  },
      { n: 3, x: 44,  y: 158, label: 'Tricepsz'     },
      { n: 4, x: 152, y: 128, label: 'Lapocka'      },
      { n: 5, x: 128, y: 172, label: 'Has'          },
      { n: 6, x: 152, y: 200, label: 'Csípőlapát'   },
      { n: 7, x: 108, y: 300, label: 'Comb'         },
    ].map((p) => (
      <g key={p.n}>
        <circle cx={p.x} cy={p.y} r="10" fill="#d97706" stroke="#fff" strokeWidth="2" />
        <text
          x={p.x}
          y={p.y + 4}
          fontSize="11"
          fontWeight="700"
          fill="#fff"
          textAnchor="middle"
          fontFamily="Inter, sans-serif"
        >
          {p.n}
        </text>
      </g>
    ))}
  </svg>
);

export default CaliperSitesIllustration;
